<template>
  <div>
    <div class="contents">
      <b-form @submit="onSubmit">
        <div class="filter-box-2">
          <div>
            <select class="form-select-lg" v-model="searchData.searchtype">
              <option value="1">{{ $t("filter.common.title") }}</option>
              <option value="2">{{ $t("filter.common.contents") }}</option>
            </select>
          </div>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="searchData.searchname"
            />
            <button
              class="btn btn-primary btn-lg icon-search"
              type="submit"
              value=""
            ></button>
          </div>
        </div>
      </b-form>

      <table class="table board inquiry-list">
        <thead>
          <tr>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.number") }}
            </th>
            <th class="col-auto">{{ $t("title.common.title") }}</th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.support.writer") }}
            </th>
            <th class="col-auto d-lg-table-cell">
              {{ $t("title.common.date") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.status") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.note") }}
            </th>
            <th class="th-arrow"></th>
          </tr>
        </thead>
        <tbody v-if="data_yn">
          <template v-for="(item, index) in items">
            <tr :key="index">
              <td class="col-auto d-none d-lg-table-cell">{{ item.no }}</td>
              <td class="col-auto text-start">
                <div class="d-flex align-items-center">
                  <router-link
                    :to="{
                      name: 'InquiryView',
                      params: { inquiryno: item.inquiryno },
                      query: {
                        searchtype: searchData.searchtype,
                        searchname: searchData.searchname,
                      },
                    }"
                    class="text-truncate more"
                  >
                    {{ item.title }}
                  </router-link>
                  <div class="ms-1 ms-md-2">
                    <img
                      src="/img/icon_new.gif"
                      class="ms-1"
                      v-if="$dayjs().diff(item.timezone_date, 'day') < 8"
                    />
                  </div>
                </div>
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                {{ item.firstname }} {{ item.lastname }}
              </td>
              <td class="col-auto d-lg-table-cell text-date">
                {{ item.timezone_date | dateformat }}
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                <button
                  class="btn btn-primary btn-xs"
                  :class="{ 'btn-outline-secondary': item.viewflag === '0' }"
                  @click="setFlag(item.inquiryno, item.viewflag)"
                >
                  {{ item.viewflag | status5 }}
                </button>
              </td>
              <td class="col-auto d-none d-lg-table-cell fs-14">
                <label class="text-green" v-if="item.deleteflag === '0'">
                  {{ $t("filter.support.ok") }}
                </label>
                <label
                  class="text-danger text-opacity-75"
                  v-else-if="item.deleteflag === '1'"
                >
                  {{ $t("filter.common.delete") }}
                </label>
                <label v-else>-</label>
              </td>
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="col-auto d-lg-none d-md-tabel-cell"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td class="text-start" colspan="6">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.number") }}</div>
                    <div class="col-6">{{ item.no }}</div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{ $t("title.support.writer") }}</div>
                    <div class="col-6">
                      {{ item.firstname }} {{ item.lastname }}
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-6">{{ $t("title.common.status") }}</div>
                    <div class="col-6">
                      <button
                        class="btn btn-primary btn-xs"
                        :class="{
                          'btn-outline-secondary': item.viewflag === '0',
                        }"
                        @click="setFlag(item.inquiryno, item.viewflag)"
                      >
                        {{ item.viewflag | status5 }}
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.note") }}</div>
                    <div class="col-6 fs-14">
                      <label class="text-green" v-if="item.deleteflag === '0'">
                        {{ $t("filter.support.ok") }}
                      </label>
                      <label
                        class="text-danger text-opacity-75"
                        v-else-if="item.deleteflag === '1'"
                      >
                        {{ $t("filter.common.delete") }}</label
                      >
                      <label v-else>-</label>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="6" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>

      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="page_total"
        v-model="searchData.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="page_total > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav>
    </div>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/support";

export default {
  name: "InquiryList",

  data() {
    return {
      searchData: {
        searchtype:
          this.$route.query.searchtype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchtype) ||
          1,
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
      },
      page_total: 1,
      total_cnt: 0,
      data_yn: true,
      rows: 10,
      items: [],
      view_hide: null,
    };
  },
  watch: {
    "searchData.searchtype": function () {
      this.searchData.pageno = 1;
      this.getList();
    },
    "searchData.searchname": function () {
      this.searchData.pageno = 1;
      this.getList();
    },
    "searchData.pageno": function () {
      this.getList();
    },
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      this.getList();
    },
    getList() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.getInquiryList(this.searchData, (flag, data, code) => {
        console.log(flag, data);
        if (flag) {
          if (data.inquirylistcnt <= 0) {
            this.data_yn = false;
          } else {
            this.data_yn = true;
          }
          this.total_cnt = data.inquirylistcnt;
          this.page_total = Math.ceil(data.inquirylistcnt / this.rows);
          this.items = data.inquirylist;
        } else {
          this.data_yn = false;
          this.page_total = 0;
          if (code === "300") {
            this.$notify({
              group: "alert",
              type: "warn",
              text: data,
            });
          } else alert(data);
        }
      });
    },
    setFlag(inquiryno, viewflag) {
      // alert(viewflag);

      if (viewflag % 2 == 0) {
        viewflag = 1;
      } else {
        viewflag = 0;
      }

      ax.getInquiryStatus(inquiryno, viewflag, (flag, data) => {
        if (flag) {
          this.getList();
        } else {
          alert(data.message);
        }
      });
      // }
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
  created() {
    this.getList();
  },
};
</script>
